import { render } from "./SFAReport.vue?vue&type=template&id=673ac593"
import script from "./SFAReport.vue?vue&type=script&lang=js"
export * from "./SFAReport.vue?vue&type=script&lang=js"

import "./SFAReport.vue?vue&type=style&index=0&id=673ac593&lang=css"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__